import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { ROOT_URL } from '../../../../actions/root_url';
import axios from 'axios';

class ProductEditColorsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      editing: false,
    };
  }

  componentDidMount() {
    this.getColorsData();
  }

  getColorsData = () => {
    if (this.props.Product_id) {
      this.setState({editing: true});
      axios({
        method: 'get',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        url: `${ROOT_URL}v1/product/${this.props.Product_id}/color`,
      })
        .then(res => {
          this.setState({ rows: res.data, eidting: false })
        }).catch((err) => {
          this.setState({editing: false});
          alert(JSON.stringify(err));
        })
    }
  }

  addColor = () => {
    let { rows } = this.state;
    const newRow = {
      Product_id: this.props.Product_id,
      Name: '',
      idx: rows.length + 1,
    }
    this.setState({
      rows: [newRow, ...this.state.rows]
    })
  }

  dlColor = (idx) => {
    let rows = this.state.rows.filter((obj) => obj.idx !== idx);
    rows.map((r, i) => {
      rows[i].idx = i + 1;
    });
    this.setState({
      rows
    });
  }

  deleteColor = (id) => {
    axios({
      method: 'delete',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      url: `${ROOT_URL}v1/product/${this.props.Product_id}/color/${id}`,
    })
      .then(res => {
        this.getColorsData();
      }).catch((err) => {
        alert(JSON.stringify(err));
      })
  }

  createColor = (data) => {
    axios({
      method: 'post',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      url: `${ROOT_URL}v1/product/${this.props.Product_id}/color`,
      data,
    })
      .then(res => {
        this.getColorsData();
      }).catch((err) => {
        alert(JSON.stringify(err));
      })
  };

  editColor = (data, id) => {
    axios({
      method: 'put',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      url: `${ROOT_URL}v1/product/${this.props.Product_id}/color/${id}`,
      data,
    })
      .then(res => {
        this.getColorsData();
      }).catch((err) => {
        alert(JSON.stringify(err));
      })
  }

  render() {
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleRowUpdated = (row) => {
      if ((row || { key: '' }).key == 'Enter') {
        // edit or create
        if (!row.updated.Name) {
          alert('Color cannot be empty')
          return
        }
        let newRow = this.state.rows;
        newRow[row.rowIdx] = {
          ...newRow[row.rowIdx],
          ...row.updated,
        }
        if (newRow[row.rowIdx].Color_id) {// edit
          this.editColor({ name: row.updated.Name }, newRow[row.rowIdx].Color_id)
        } else { // create
          this.createColor({ name: row.updated.Name });
        }
      }
    };

    const columns = [
      {
        key: 'idx',
        name: <Translate value="idx" />,
        resizable: true,
        width: 40,
        getRowMetaData: row => row,
        formatter: ({ dependentValues }) => {
          return <div >
            <Button
              bsStyle="danger"
              type="button"
              onClick={() => {
                if(dependentValues.Color_id) {
                  this.deleteColor(dependentValues.Color_id);
                } else {
                  this.dlColor(dependentValues.idx);
                }
              }}
            >
              x
            </Button>
          </div>
        },
      },
      {
        key: 'Name',
        name: <Translate value="color" />,
        resizable: true,
        editable: true,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <ButtonToolbar>
            <Button
              type="button"
              bsStyle="primary"
              onClick={this.addColor}
            >
              <em className="fa fa-plus" /><Translate value="add" />
            </Button>
          </ButtonToolbar>
          <div style={{ maxWidth: '100%', marginTop: '5px' }}>
            <ReactDataGrid
              rowKey="colors_table"
              enableCellSelect
              onRowUpdated={handleRowUpdated}
              rowHeight={30}
              minHeight={250}
              loading={this.state.editing}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

export default ProductEditColorsModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/product/ProductEditColorsModal.jsx